module.exports = __webpack_public_path__ + "img/myr.b50641c6.svg";